import { render, staticRenderFns } from "./AssignTableGroups.vue?vue&type=template&id=b52ae1f4&scoped=true&"
import script from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
export * from "./AssignTableGroups.vue?vue&type=script&lang=ts&"
import style0 from "./AssignTableGroups.vue?vue&type=style&index=0&id=b52ae1f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52ae1f4",
  null
  
)

export default component.exports